export default __webpack_public_path__ + "static/media/basa.a8396167.png";